import { Modal } from "react-bootstrap"
import AppModal from "../../Common/AppModal"
import { Character, GameInstance } from "../../../types"
// import { useDispatch } from "react-redux"
import CharThumbnail from "./CharThumbnail"
import { useEffect, useState } from "react"
import { socket } from "../../../api"
import { getNodeByChar } from "../helpers/dataHelpers"
import { expGameInstance } from "../ThreeTestFC"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHandshake } from "@fortawesome/free-solid-svg-icons"
import { faHourglassHalf } from "@fortawesome/free-regular-svg-icons"
import { getActionIcon, getConditionColor, getConditionIcon, renderWithIcons } from "../helpers/uiHelpers"

type Props = {
    character: Character
    gameInstance: GameInstance
}
const Actions: React.FC<Props> = (props) => {
    // const dispatch: any = useDispatch();
    const [actionResponse, setActionResponse] = useState<string[]>([])
    const node = getNodeByChar(expGameInstance!, props.character.id)
    const gateId = node?.gateIds && node.gateIds[0]
    const clueIds = node?.clueIds ?? []

    useEffect(() => {
        socket.on("actionResponse", (res: string[]) => {
            console.log("Message received", res)
            setActionResponse(res)
        })

        return () => {
            socket.off("actionResponse");
        }
    });

    return (
        <AppModal name="actions" title="Actions" onClose={() => { setActionResponse([]) }}>
            <Modal.Body className="p-2">
                <div style={{ width: "120px", margin: "0 auto"}}>
                    <CharThumbnail character={props.character} size={120} displayHS />
                </div>

                <div className="mt-4"></div>

                <div className="px-2 py-2 clickable strong italic action" onClick={() => { socket.emit("rest") }}>
                    <span className="stat-icon-wrapper">{getActionIcon("rest")}</span> <span className="statvalue">Rest:</span> Recover Health and Sanity <FontAwesomeIcon className="ms-2" icon={faHourglassHalf} /> {(props.gameInstance.map.durations?.rest ?? 60) / 60} h
                </div>

                {gateId && <div className="px-2 py-2 clickable strong italic action" onClick={() => { socket.emit("encounterGate", { logicBlockId: (gateId) }) }}>
                    <span className="stat-icon-wrapper">{getActionIcon("otherworld")}</span> <span className="statvalue">Enter Other World portal</span> <FontAwesomeIcon className="ms-2" icon={faHourglassHalf} /> {(props.gameInstance.map.durations?.encounter ?? 60) / 60} h
                </div>}

                {node?.action && <div className="px-2 py-2 clickable strong italic action" onClick={() => { socket.emit("encounterNodeAction") }}>
                    <span className="stat-icon-wrapper">{getActionIcon("clue")}</span> <span className="statvalue">{node.action.title}</span> <FontAwesomeIcon className="ms-2" icon={faHourglassHalf} /> {(props.gameInstance.map.durations?.encounter ?? 60) / 60} h
                </div>}

                {clueIds.map((c, i) => {
                    return (<div key={i} className="px-2 py-2 clickable strong italic action" onClick={() => { socket.emit("encounterClue", { logicBlockId: (c) }) }}>
                        <span className="stat-icon-wrapper">{getActionIcon("clue")}</span> <span className="statvalue">Investigate the Clue</span> <FontAwesomeIcon className="ms-2" icon={faHourglassHalf} /> {(props.gameInstance.map.durations?.encounter ?? 60) / 60} h
                    </div>)
                })}

                {(props.character.conditions.find(c => c.name === "debt") !== undefined) &&
                    <div className="px-2 py-2 clickable strong italic action" onClick={() => { socket.emit("resolveCondition", { conditionName: "debt" }) }}>
                        <span className="stat-icon-wrapper">{getConditionIcon("debt")}</span> <span style={{color: getConditionColor("debt")}} className="statvalue">Debt</span> - Try to settle your debt <FontAwesomeIcon icon={faHandshake} /> <FontAwesomeIcon className="ms-2" icon={faHourglassHalf} /> {(props.gameInstance.map.durations?.condition ?? 60) / 60} h
                    </div>
                }

                {(props.character.conditions.find(c => c.name === "detained") !== undefined) &&
                    <div className="px-2 py-2 clickable strong italic action" onClick={() => { socket.emit("resolveCondition", { conditionName: "detained" }) }}>
                        <span className="stat-icon-wrapper">{getConditionIcon("detained")}</span> <span style={{color: getConditionColor("detained")}} className="statvalue">Detained</span> - Try to end your imprisonment <FontAwesomeIcon icon={faHandshake} /> <FontAwesomeIcon className="ms-2" icon={faHourglassHalf} /> {(props.gameInstance.map.durations?.condition ?? 60) / 60} h
                    </div>
                }

                {(props.character.conditions.find(c => c.name === "lost_in_time_and_space") !== undefined) &&
                    <div className="px-2 py-2 clickable strong italic action" onClick={() => { socket.emit("resolveCondition", { conditionName: "lost_in_time_and_space" }) }}>
                        <span className="stat-icon-wrapper">{getConditionIcon("lost_in_time_and_space")}</span> <span style={{color: getConditionColor("lost_in_time_and_space")}} className="statvalue">Lost in Time and Space</span> -<FontAwesomeIcon className="ms-2" icon={faHourglassHalf} /> {(props.gameInstance.map.durations?.condition ?? 60) / 60} h
                    </div>
                }

                {actionResponse.map(r => <div key={r} className="my-2">{renderWithIcons(r)}</div>)}

            </Modal.Body>
            <Modal.Footer className="p-1" style={{justifyContent: "center"}}>

            </Modal.Footer>
        </AppModal>
    )
}
export default Actions